import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { data } from '../../evn/evn'; // Ensure the correct path
import Sidebar from '../AdminComponents/SideBar';
import { useNavigate } from 'react-router-dom';
import styles from './CompanyManagement.module.css'; // Adjust the path as needed

const CompanyManagement = () => {
  const [companies, setCompanies] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [searchType, setSearchType] = useState('id');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCompanies = async () => {
      const ip = data.evn;
      const token = localStorage.getItem('adminToken');
      if (!token) {
        navigate('/.admin');
        return false;
    }

      try {
        const response = await axios.get(`${ip}/admin/companies`, {
          headers: { 'x-auth-token': token },
        });
        setCompanies(response.data.companies);
        setSearchResults(response.data.companies);
      } catch (error) {
        console.error("There was an error fetching the companies:", error);
      }
    };

    fetchCompanies();
  }, []);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    if (!event.target.value) {
      setSearchResults(companies);
    } else {
      const filteredCompanies = companies.filter(company =>
        searchType === 'id' ? company.id.toString().includes(event.target.value)
                            : company.user_id.toString().includes(event.target.value));
      setSearchResults(filteredCompanies);
    }
  };

  const handleSearchTypeChange = (event) => {
    setSearchType(event.target.value);
    setSearchTerm('');
    setSearchResults(companies);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' && searchTerm) {
      const exactMatchCompanies = companies.filter(company => {
        if (searchType === 'id') return company.id.toString() === searchTerm;
        return company.user_id.toString() === searchTerm;
      });
      setSearchResults(exactMatchCompanies);
    }
  };

  return (
    <>
      <Sidebar />
      <div className={styles.container}>
        <div className={styles.searchContainer}>
          <select
            className={styles.searchTypeSelect}
            value={searchType}
            onChange={handleSearchTypeChange}
          >
            <option value="id">Search by ID</option>
            <option value="userId">Search by User ID</option>
          </select>
          <input
            type="text"
            placeholder={`Search by ${searchType}...`}
            value={searchTerm}
            onChange={handleSearchChange}
            onKeyPress={handleKeyPress}
            className={styles.searchInput}
          />
        </div>
        <table className={styles.table}>
          <thead>
            <tr className={styles.tableRow}>
              <th className={styles.tableHeader}>Company ID</th>
              <th className={styles.tableHeader}>User ID</th>
              <th className={styles.tableHeader}>Company Name</th>
              <th className={styles.tableHeader}>Person</th>
              <th className={styles.tableHeader}>Email</th>
              <th className={styles.tableHeader}>Contact Number</th>
              <th className={styles.tableHeader}>Website Link</th>
              <th className={styles.tableHeader}>Address</th>
              
            </tr>
          </thead>
          <tbody>
            {searchResults.map(company => (
              <tr key={company.id} className={styles.tableRow}>
                <td className={styles.tableCell}>{company.id}</td>
                <td className={styles.tableCell}>{company.user_id}</td>
                <td className={styles.tableCell}>{company.companyName}</td>
                <td className={styles.tableCell}>{company.person}</td>
                <td className={styles.tableCell}>{company.email}</td>
                <td className={styles.tableCell}>{company.contactNumber}</td>
                <td className={styles.tableCell}>{company.websiteLink}</td>
                <td className={styles.tableCell}>{company.address}</td>
                
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default CompanyManagement;
